import React, { Component } from "react"
import { Link } from "gatsby"
// import AnchorLink from 'react-anchor-link-smooth-scroll';

import Layout from "../components/layout"
import SEO from "../components/seo"

import SimpleModal from "../components/utilities/SimpleModal"

import "./casestudycarleton.scss"

import imgQuote from "../images/quotation_mark.webp"

export default ({ pageContext }) => (
  <Layout>
    <SEO
      title={pageContext.yoast.title}
      description={pageContext.yoast.metadesc}
      ogimg={pageContext.yoast.opengraph_image}
      link={pageContext.link}
    />
    <div className="case-study-carleton-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div
            className="header-container"
            style={{
              backgroundImage: `url(${pageContext.acf.header_image.csOneHedImaLocalFile.childImageSharp.fluid.src})`,
            }}
          >
            <img src={imgQuote} alt="" />
            <h2>{pageContext.acf.header_text}</h2>
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row">
          <div className="col-md-8">
            <img
              src={
                pageContext.acf.client_logo.csOneCliLogLocalFile.childImageSharp
                  .fluid.src
              }
              className="client-logo"
              width={pageContext.acf.client_logo.media_details.width / 1.5}
              height={pageContext.acf.client_logo.media_details.height / 1.5}
              alt={pageContext.yoast.opengraph_title}
            />
          </div>
          <div className="col-md-4">
            <a
              href="https://apiold.meritmile.com/wp-content/uploads/2026/07/carleton-case-study-merit-mile.pdf"
              className="btn downloadBtn"
              target="_blank"
              rel="nofollow noopener noreferrer"
              style={{ marginTop: "4em" }}
            >
              Download the PDF here
            </a>
          </div>
          <div className="col-12">
            <div className="bar"></div>
          </div>
          <div className="col-12">
            <div
              className="first-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.first_paragraph,
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <img
              src="https://apiold.meritmile.com/wp-content/uploads/2026/07/carleton-intro.webp"
              className="results-image img-fluid"
              alt="Carleton Intro Room"
              width="1400px"
              style={{
                marginTop: "2em",
                marginBottom: "6em",
                transform: "scale(1.2)",
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h3>Challenge</h3>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <p>Navigating the increasingly complex landscape of consumer lending presents a significant challenge for organizations seeking to maintain accuracy, efficiency, and regulatory compliance.</p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              <b>Lenders, fintechs, regtechs, and automotive finance providers must manage intricate loan structures, evolving state and federal regulations, and high volumes of transactions—all while ensuring that every calculation, disclosure, and document is precise.</b> However, many organizations still rely on fragmented systems, manual processes, or outdated tools, increasing the risk of inconsistencies, operational inefficiencies, and compliance exposure. Carleton Inc. delivers compliant loan calculation software, document generation, and compliance support designed to ensure accuracy and consistency across the lending lifecycle. Yet, the challenge lies in effectively communicating the critical role that precise calculations and integrated compliance solutions play in mitigating risk and enabling seamless operations. 
            </p>
          </div>
          <div className="col-12 col-md-6">
            <p>
              In an environment where even small errors in APRs, fees, or disclosures can lead to significant financial and legal consequences, many organizations underestimate the importance of purpose-built, compliant calculation engines or struggle to differentiate between basic tools and enterprise-grade solutions. As a result, Carleton faced the need to <b>elevate market awareness around the importance of accuracy, compliance, and integration in loan origination and servicing</b>. The company required a strategic public relations approach to educate target audiences, reinforce trust in its decades-long expertise, and position its solutions as essential infrastructure for lenders aiming to reduce risk, improve operational efficiency, and stay aligned with constantly evolving regulatory requirements.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <img
              src="https://apiold.meritmile.com/wp-content/uploads/2026/07/carleton-stats.webp"
              className="results-image img-fluid"
              alt="Carleton Stats"
              width="1000px"
              style={{
                marginTop: "2em",
                marginBottom: "6em",
                transform: "scale(1.2)",
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div
              className="third-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.third_paragraph,
              }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <p>
              To bring this messaging to life, Merit Mile created compelling story angles grounded in real-world industry challenges, such as calculation errors, compliance risk, and operational inefficiencies. These narratives highlighted the tangible impact of Carleton’s solutions in reducing risk and improving performance across the lending lifecycle. Supporting these efforts, Merit Mile secured executive interview opportunities and developed thought leadership content that showcased Carleton’s deep industry expertise and decades-long track record in compliant lending technologies.
            </p>
          </div>
          <div className="col-md-6">
            <p>Focusing on top-tier and trade media, <b>Merit Mile positioned Carleton executives as go-to experts on regulatory trends, loan accuracy, and the evolving demands of modern lending infrastructure</b>. Through strategic media placements, contributed articles, and expert commentary, the program reinforced Carleton’s reputation as an essential technology partner for organizations seeking to enhance precision, streamline operations, and maintain compliance in an increasingly scrutinized financial landscape.</p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <h3>Results</h3>
            <p>
              With the support of Merit Mile Public Relations, Carleton Inc. has strengthened its visibility and credibility both qualitatively and quantitively. 
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <img
              src="https://apiold.meritmile.com/wp-content/uploads/2026/07/carleton-results.webp"
              className="results-image img-fluid"
              alt="Carleton Results"
              width="800px"
              style={{
                marginTop: "1em",
                marginBottom: "4em",
              }}
            />
          </div>
          <div className="col-md-6">
            <hr />
            <img
              src="https://apiold.meritmile.com/wp-content/uploads/2026/07/carleton-results-smaller.webp"
              className="results-image img-fluid"
              alt="Carleton Results Small"
              width="800px"
              style={{
                marginTop: "1em",
                marginBottom: "0em",
              }}
            />
            <hr />
            <p>Within the lending, fintech, regtech, and automotive finance industries, Carleton has become a more active voice in conversations while also taking more authoritative ownership around the topics of loan accuracy, compliance, and operational efficiency. Through targeted media outreach and strategic storytelling, Carleton has been featured in key financial services and trade publications, highlighting its expertise in compliant loan calculations, document generation, and regulatory alignment. With <b>over 11 million impressions and a return on monthly PR spend of 9.5X</b>, Carleton has successfully transformed its market posture from a behind-the-scenes technology provider to a recognized thought leader and preferred partner for lenders seeking compliant, accurate, and efficient loan processes. This sustained momentum continues to fuel stronger brand recognition, higher-quality inbound opportunities, and a defensible competitive advantage across its core verticals.</p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 text-center">
            <img
              src="https://apiold.meritmile.com/wp-content/uploads/2026/07/carleton-logos.webp"
              className="results-image img-fluid"
              alt="Carleton Logos"
              width="1000px"
              style={{ marginBottom: "2em" }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <h3>Outcome</h3>
            <p>
              Carleton's story illustrates a broader truth for B2B organizations in regulated industries: the strength of your technology is only as valuable as your audience's understanding of it. By translating complex, compliance-driven solutions into clear narratives backed by media credibility, Carleton has reinforced its position as a trusted name in lending technology and continues to build on that momentum.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              If your organization is navigating a similarly complex story where deep expertise needs to translate into market visibility and trust, Merit Mile can help. Visit <a href="/case-studies/">meritmile.com/case-studies</a> to explore additional PR client success stories, <a href="/services/public-relations/">meritmile.com/services/public-relations</a> to learn more about how we build PR programs that turn technical authority into industry recognition or reach out at <a href="/contact-us/">meritmile.com/contact-us</a> to start the conversation.
            </p>
          </div>
          <div className="col-12 col-md-6 text-center">
            <img
              src="https://apiold.meritmile.com/wp-content/uploads/2026/07/carleton-outcome.webp"
              className="intro-image"
              width=""
              alt="Carleton Outcome"
              style={{ marginBottom: "2em", maxWidth: "90%" }}
            />
          </div>
        </div>
      </div>
      <div className="fullWidthGrayCTA">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5>
                For more information or to arrange a conversation with a Merit Mile marketing specialist, please email us at <a href="mailto:Hello@MeritMile.com?subject=Carleton%20Case%20Study%20Inquiry">
                  <b style={{ color: "black", textDecoration: "underline" }}>Hello@MeritMile.com</b>
                </a> or call us at 1-561-362-8888 today!
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div className="fullWidthImageWrapper">
        <img
          src="https://www.meritmile.com/uploads/2021/09/mm-divider.jpg"
          alt="Merit Mile Icon Divider"
          className="img-fluid"
        />
      </div>
      <div className="about-wrapper">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2>About Merit Mile</h2>
            </div>
          </div>
          <div className="row margin-b">
            <div className="col-md-6">
              <p>
                Established in 2007 in Boca Raton, FL, Merit Mile is a marketing
                services provider focused on helping companies and corporate
                marketing departments build brands, drive sales revenue, and
                garner publicity in their respective industries. Our unique
                differentiator at Merit Mile is our ability to 100% own the
                message, the publicity, and the demand generation aspects of the
                corporate marketing function. Clients hire us and rehire us for
                our ability to refine their messaging/value proposition, develop
                top and mid-funnel leads, and get the type of editorial
                publicity that differentiates them from their competitors. From
                branding to PR to demand generation, Merit Mile is the
                high-octane fuel that invigorates corporate growth engines. To
                learn more, please email us at Hello@MeritMile.com, call us at
                1-561-362-888, or visit us at www.MeritMile.com.{" "}
              </p>
            </div>
            <div className="col-md-6">
              <img
                className="img-fluid"
                src="https://www.meritmile.com/uploads/2021/06/mm-headquarter.webp"
                alt="Merit Mile Headquarter in Boca Raton, FL"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container quote-wrapper">
        <div className="row">
          <div className="col-12">
            <p>
              For more insights and to connect
              <br />
              with Merit Mile{" "}
              <a href="mailto:Hello@MeritMile.com?subject=Teldoc%20Health%20Microsoft%20Case%20Study%20Inquiry">
                <b style={{ color: "black" }}>email us here</b>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
